<template>
  <div class="animated fadeIn">
    <!-- <div>
      <ConflictsModal v-if="conflicts.length" :conflicts="conflicts" />
    </div> -->
    <b-row>
      <b-col lg="3">
        <span class="tabtext">{{ current_zip.ZipCode }}</span>
      </b-col>
      <b-col lg="3">
        <span class="tabtext">{{ current_zip.City }}</span>
      </b-col>
      <b-col lg="2">
        <span class="tabtext">{{ current_zip.State }}</span>
      </b-col>
      <b-col lg="2">
        <c-switch
          v-if="conflict_count == 0 || n_user.n_current_user.IsSU"
          width="100px"
          class="mx-3 pt-2"
          color="primary"
          variant="pill"
          id="Include"
          v-model="current_zip.Include"
          @change.native="SetZipStatus"
        />
      </b-col>
      <b-col lg="2">
        <b-button
          :disabled="is_setting_conflicts"
          v-if="conflict_count > 0"
          size="md"
          variant="outline-danger"
          @click="setActiveConflicts"
        >
          <i class="fa fa-exclamation-triangle"></i>
          {{ conflicts_label
          }}<i
            v-show="is_setting_conflicts"
            class="fa fa-refresh fa-spin localBold ml-2"
          ></i>
        </b-button>
      </b-col>
    </b-row>
    <hr />
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { Switch as cSwitch } from "@coreui/vue";
import ConflictsModal from "@/components/dialogs/ConflictsModal.vue";

export default {
  name: "ZipRow",
  components: { cSwitch, ConflictsModal },
  props: {
    seminar_object: { type: Object },
    zip_object: { type: Object }
  },
  created() {
    //console.log("created " + this.current_zip.ZipCode);
    //console.log(this.current_zip);
    this.current_zip.Include = !!this.current_zip.Include;
    //this.getConflicts();
    this.getConflictCount();
  },
  mounted() {
    //console.log("mount " + this.current_zip.ZipCode);
  },
  data() {
    return {
      current_seminar: this.seminar_object,
      current_zip: this.zip_object,
      IsSelected: false,
      conflicts: [],
      conflict_count: 0,
      is_setting_conflicts: false
    };
  },
  computed: {
    ...mapState(["seminar", "territory", "zip", "n_user"]),
    conflicts_label() {
      if (this.conflict_count === 1) {
        return "1 Conflict";
      } else {
        return this.conflict_count + " Conflicts";
      }
    }
    // IsSelected() {
    //   if (this.current_zip.Include === 1) {
    //     return true;
    //   }
    //   return false;
    // }
  },
  methods: {
    SetZipStatus: function(event) {
      //console.log(event);
      //this.current_zip.Include = event.target.checked;
      this.saveField(event.target.checked);
    },
    saveField: function(isChecked) {
      var _operation = {
        SeminarID: this.current_seminar.SeminarID,
        ZipCode: this.current_zip.ZipCode,
        ValueToSet: isChecked
      };

      this.$store.dispatch("zip/setZipStatus", _operation).then(
        this.$store
          .dispatch("seminar/RefreshZips", this.current_seminar.SeminarID)
          .then(response => {
            this.$store.state.seminar.seminar_edit.Zips =
              response.data["RefreshZipsResult"];
          })

        //this.$emit("CurrentZipCollectionChange")
      );
    },
    async getConflictCount() {
      var _operation = {
        SeminarID: this.current_seminar.SeminarID,
        TerritoryID: this.current_seminar.TerritoryID,
        ZipCode: this.current_zip.ZipCode
      };
      await this.$store
        .dispatch("zip/getConflictCount", _operation)
        .then(response => {
          this.conflict_count = response.data["ConflictCountResult"];
        });
    },
    async getConflicts() {
      var _operation = {
        SeminarID: this.current_seminar.SeminarID,
        TerritoryID: this.current_seminar.TerritoryID,
        ZipCode: this.current_zip.ZipCode
      };
      await this.$store
        .dispatch("zip/getConflicts", _operation)
        .then(response => {
          this.conflicts = response.data["ConflictsResult"];
        });
    },
    showConflicts: function() {},
    async setActiveConflicts() {
      this.is_setting_conflicts = true;
      await this.getConflicts();
      await this.$store.dispatch("zip/setActiveConflicts", this.conflicts);
      this.$bvModal.show("modal-2");
      this.is_setting_conflicts = false;
    }
  },
  watch: {}
};
</script>

<style lang="scss" scoped>
hr {
  border: none;
  border-top: 1px dotted #333;
  color: #fff;
  background-color: #fff;
  height: 1px;
  width: 100%;
}
</style>
